var _path, _mask, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfigsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6241 4.13152C10.6141 4.13152 10.6029 4.13266 10.5917 4.13467L7.81936 4.68946C7.78954 4.69549 7.76202 4.7104 7.74051 4.73163L1.04512 11.4298C0.984911 11.4904 0.984911 11.5893 1.04541 11.6499L3.26325 13.8685C3.32346 13.929 3.42181 13.9296 3.48289 13.8685L10.1774 7.17081C10.1992 7.14901 10.2138 7.12176 10.2196 7.09193L10.7747 4.3174C10.789 4.24683 10.7543 4.1995 10.7322 4.17741C10.7139 4.15905 10.6775 4.13152 10.6241 4.13152Z",
    stroke: "#001E64",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_5964_37506",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4375 7.42969H10.4435H10.4375Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4375 7.42969H10.4435H10.4375Z",
    fill: "#252E58"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4375 5.92969H10.4435V8.92969H10.4375V5.92969ZM10.4435 8.92969H10.4375V5.92969H10.4435V8.92969Z",
    fill: "#001E64",
    mask: "url(#path-2-inside-1_5964_37506)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.69837 8.51562L2.16907 7.9878C1.34989 7.16824 1.34989 5.84064 2.16907 5.02137C2.58024 4.60972 3.117 4.40203 3.65346 4.40203C4.18993 4.40203 4.7264 4.60972 5.13786 5.02137L5.66343 5.54546",
    stroke: "#001E64",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14474 8.8013L21.253 20.9152C22.0722 21.7347 22.0722 23.0623 21.253 23.8853C20.4338 24.7049 19.1068 24.7049 18.2876 23.8853L6.17969 11.768",
    stroke: "#001E64",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88517 19.1906L5.48161 23.5963C4.66242 24.4158 3.33545 24.4158 2.51282 23.5963C1.69364 22.7767 1.69364 21.4491 2.51282 20.6298L6.92012 16.2242",
    stroke: "#001E64",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5816 10.6797L16.9141 12.3438",
    stroke: "#001E64",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7239 7.59646L13.9453 9.375",
    stroke: "#001E64",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.99 6.53136C24.8512 8.89166 22.9218 10.8274 20.5632 10.9748C17.6887 11.1547 15.3212 8.76486 15.5371 5.87789C15.7097 3.56779 17.591 1.68426 19.9003 1.51473C20.1471 1.49666 20.3903 1.49723 20.6283 1.51559C21.2972 1.56722 21.5974 2.38105 21.1232 2.85581L19.4329 4.54685L21.8259 6.94071L23.6211 5.14467C24.073 4.69229 24.8621 4.93928 24.9516 5.57267C24.9954 5.88391 25.0092 6.20462 24.99 6.53136Z",
    stroke: "#001E64",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigsIcon);
export default __webpack_public_path__ + "static/media/configsIcon.52f5fcae996ab9ed0fb42b0cfe4e0d37.svg";
export { ForwardRef as ReactComponent };